const initialState = {
  liveRegion: []
};

export const setLiveRegionText = (text) => ({
  type: 'app/setLiveRegionText',
  payload: text
});

export const clearLiveRegionText = () => ({
  type: 'app/clearLiveRegionText'
});

export default function appReducer(state = initialState, action) {
  const {type, payload} = action;

  switch (type) {
    case 'app/setLiveRegionText':
      return {
        ...state,
        liveRegion: state.liveRegion.concat([payload])
      }
    case 'app/clearLiveRegionText':
      return {
        ...state,
        liveRegion: []
      }
    default:
      return state;
  }
}